var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"0"}},[_c('h2',[_vm._v("FluxHitRate")]),_c('VodOptinBtn'),_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"C"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }